/* istanbul ignore file */
import React from 'react';
import { ListBreadcrumbItem, Breadcrumbs } from 'framework/ui/BreadCrumbs';
import { useContactUrl } from 'domain/sales/contact/contactRouting';

const ContactsBreadcrumbs = ({ children = null }: { children?: React.ReactNode }) => {
  const { getListUrl } = useContactUrl();

  return (
    <Breadcrumbs>
      <ListBreadcrumbItem entity="Contacts" link={getListUrl()} />
      {children}
    </Breadcrumbs>
  );
};

export default ContactsBreadcrumbs;
